import React from "react";
import { __ } from "@wordpress/i18n";
import { FacebookIcon, InstagramIcon, YoutubeIcon, TwitterIcon, ReviewIcon, TikTokIcon,
    InstagramPreview, FacebookPreview, TwitterPreview, YoutubePreview,
    ReviewPreview, TikTokPreview } from "../icons";

const UPSELL_TITLE = __('Did you know?', 'sb-common');
const OR_CREATE_FEED_ALL = __('Or create a feed for Instagram, Facebook, Twitter or YouTube', 'sb-common');
const UPSELL_DESC_ALL = __('You can also add Instagram, Facebook, Twitter and YouTube posts into your feed using our Social Wall plugin.', 'sb-common');

const smashBlocks = [
    {
        id: 'instagram',
        name: 'smashballoon/instagram-feed',
        customizerPage: 'sbi-feed-builder',
        title: __('Instagram Feed', 'sb-common'),
        logo: <InstagramIcon />,
        preview: <InstagramPreview />,
        getStarted: __('Get started with your first feed from Instagram', 'sb-common'),
        createFeed: __('Create Instagram Feed', 'sb-common'),
        selectFeed: __('Select an Instagram Feed to embed', 'sb-common'),
        orCreateFeed: __('Or create a feed for Facebook, Twitter or YouTube', 'sb-common'),
        upsellTitle: UPSELL_TITLE,
        upsellDescFree: __('You can display feeds of Instagram photos, videos and stories using the Pro version.', 'sb-common'),
        upsellDesc: __('You can also add Facebook, Twitter and YouTube posts into your feed using our Social Wall plugin.', 'sb-common'),
    },
    {
        id: 'facebook',
        name: 'smashballoon/facebook-feed',
        customizerPage: 'cff-feed-builder',
        title: __('Facebook Feed', 'sb-common'),
        logo: <FacebookIcon />,
        preview: <FacebookPreview />,
        getStarted: __('Get started with your first feed from your Facebook Page or Group', 'sb-common'),
        createFeed: __('Create Facebook Feed', 'sb-common'),
        selectFeed: __('Select a Facebook Feed to embed', 'sb-common'),
        orCreateFeed: __('Or create a feed for Instagram, Twitter or YouTube', 'sb-common'),
        upsellTitle: UPSELL_TITLE,
        upsellDescFree: __('You can display feeds of Facebook photos, videos, albumns, events and more using the Pro version.', 'sb-common'),
        upsellDesc: __('You can also add Instagram, Twitter and YouTube posts into your feed using our Social Wall plugin.', 'sb-common'),
    },
    {
        id: 'twitter',
        name: 'smashballoon/twitter-feed',
        customizerPage: 'ctf-feed-builder',
        title: __('Twitter Feed', 'sb-common'),
        logo: <TwitterIcon />,
        preview: <TwitterPreview />,
        getStarted: __('Get started with your first feed from Twitter', 'sb-common'),
        createFeed: __('Create Twitter Feed', 'sb-common'),
        selectFeed: __('Select a Twitter Feed to embed', 'sb-common'),
        orCreateFeed: __('Or create a feed for Instagram, Facebook or YouTube', 'sb-common'),
        upsellTitle: UPSELL_TITLE,
        upsellDescFree: __('You can display feeds of Twitter photos, videos, albumns, events and more using the Pro version.', 'sb-common'),
        upsellDesc: __('You can also add Instagram, Facebook and YouTube posts into your feed using our Social Wall plugin.', 'sb-common'),
    },
    {
        id: 'youtube',
        name: 'smashballoon/youtube-feed',
        customizerPage: 'sby-feed-builder',
        title: __('YouTube Feed', 'sb-common'),
        logo: <YoutubeIcon />,
        preview: <YoutubePreview />,
        getStarted: __('Get started with your first feed from YouTube', 'sb-common'),
        createFeed: __('Create YouTube Feed', 'sb-common'),
        selectFeed: __('Select a YouTube Feed to embed', 'sb-common'),
        orCreateFeed: __('Or create a feed for Instagram, Facebook or Twitter', 'sb-common'),
        upsellTitle: UPSELL_TITLE,
        upsellDescFree: __('You can display feeds of YouTube videos, playlists and channels using the Pro version.', 'sb-common'),
        upsellDesc: __('You can also add Instagram, Facebook and Twitter posts into your feed using our Social Wall plugin.', 'sb-common'),
    },
    {
        id: 'reviews',
        name: 'smashballoon/reviews-feed',
        customizerPage: 'sbr',
        title: __('Reviews Feed', 'sb-common'),
        logo: <ReviewIcon />,
        preview: <ReviewPreview />,
        getStarted: __('Get started with your first feed from your Google or Yelp reviews.', 'sb-common'),
        createFeed: __('Create Reviews Feed', 'sb-common'),
        selectFeed: __('Select a Reviews Feed to embed', 'sb-common'),
        orCreateFeed: OR_CREATE_FEED_ALL,
        upsellTitle: UPSELL_TITLE,
        upsellDescFree: __('You can display feeds of TripAdvisor and Facebook reviews using the Pro version.', 'sb-common'),
        upsellDesc: UPSELL_DESC_ALL,
    },
    {
        id: 'tiktok',
        name: 'smashballoon/tiktok-feed',
        customizerPage: 'sbtt',
        title: __('TikTok Feed', 'sb-common'),
        logo: <TikTokIcon />,
        preview: <TikTokPreview />,
        getStarted: __('Get started with your first feed from TikTok', 'sb-common'),
        createFeed: __('Create TikTok Feed', 'sb-common'),
        selectFeed: __('Select a TikTok Feed to embed', 'sb-common'),
        orCreateFeed: OR_CREATE_FEED_ALL,
        upsellTitle: UPSELL_TITLE,
        upsellDescFree: __('You can display feeds of TikTok videos using the Pro version.', 'sb-common'),
        upsellDesc: UPSELL_DESC_ALL,
    }
];

export {smashBlocks};
